import { useEffect, useRef } from 'react';

export const usePolling = (
  callback: () => Promise<void>,
  interval: number,
  condition: boolean
) => {
  const savedCallback = useRef<() => Promise<void>>();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    if (!condition) return;

    const tick = async () => {
      if (savedCallback.current) {
        await savedCallback.current();
      }
    };

    // Call immediately
    tick();

    // Then set up interval
    const id = setInterval(tick, interval);

    return () => clearInterval(id);
  }, [interval, condition]);
};

